import React, { useEffect, useState, useMemo } from "react";
import HeaderTable from "../DataTable/HeaderTable";
import PaginationComponent from "../DataTable/Pagination";
import SearchTable from "../DataTable/Search";
import { Link } from "react-router-dom";
import { NepaliDatePicker } from "datepicker-nepali-reactjs";
import "./style.css";
import { changeIndexToNepali, colorScale } from "../../utils";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ModalComp from "../modals/ModalComp";
const province_data = [
  "koshi",
  "madhesh",
  "bagmati",
  "gandaki",
  "lumbini",
  "karnali",
  "Sudurpashchim",
];
export default function DistrictTable({
  comments,
  title,
  categories,
  isLoading,
}) {
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [refresh, setRrefresh] = useState(false);
  const [sorting, setSorting] = useState({ field: "", order: "" });
  const [date, setDate] = useState("");
  const ITEMS_PER_PAGE = 50;
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [modal3, setModal3] = useState(false);
  //   const toggle = () => setModal(!modal);
  //   const toggle2 = () => setModal2(!modal2);
  //   const toggle3 = () => setModal3(!modal3);
  let localData = "";
  let localData2 = "";
  let fiscalYear = "";
  if (JSON.parse(localStorage.getItem("user"))) {
    localData = JSON.parse(localStorage.getItem("user")).user.role_id;
    localData2 = JSON.parse(localStorage.getItem("user")).token;
    fiscalYear = JSON.parse(localStorage.getItem("user")).user.fiscal_year_id;
  }

  const headers = [
    { name: "क्र.स.", field: "id", sortable: false },
    { name: "मन्त्रालय", field: "comp", sortable: false },
    { name: "मन्त्रालयबाट अनुशिक्षण सम्पन्न", field: "score", sortable: false },
    {
      name: "मन्त्रालयबाट प्रारम्भिक नतिजा तयार",
      field: "action",
      sortable: false,
    },
    {
      name:
        // "मुख्यमन्त्री तथा मन्त्रिपरिषद्को कार्यालयबाट मूल्याङ्कन गर्न तय मिति",
        "मुख्यमन्त्री तथा मन्त्रिपरिषद्को कार्यालयबाट पृष्ठपोषण सम्पन्न",
      field: "action",
      sortable: false,
    },
    // {
    //   name:
    //     "मुख्यमन्त्री तथा मन्त्रिपरिषद्को कार्यालयबाट प्रारम्भिक नतिजा तयार",
    //   field: "action",
    //   sortable: false,
    // },
    // {
    //   name:
    //     "मुख्यमन्त्री तथा मन्त्रिपरिषद्को कार्यालयबाट तयार प्रारम्भिक नतिजामा मन्त्रालयबाट पृष्ठपोषण",
    //   field: "action",
    //   sortable: false,
    // },
    {
      name: "मन्त्रालयबाट पृष्ठपोषण हेरी अन्तिम नतिजा तयार",
      field: "action",
      sortable: false,
    },
  ];
  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.info.name.toLowerCase().includes(search.toLowerCase())
        // ||
        // comment.img.toLowerCase().includes(search.toLowerCase())
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [comments, currentPage, search, sorting]);
  const getDate = (event) => {
    setDate(event);
    // console.log(date);
  };
  const handleministry_id = (m_id, m_name) => {
    sessionStorage.setItem("m_id", m_id);
    sessionStorage.setItem("m_name", m_name);
  };
  return (
    <div className="card-layout">
      <ToastContainer />
      <div className="row">
        <div className="col mb-3 col-12 text-center">
          <div className="row table-heading">
            <div className="col-md-6">
              <h1 className="sub-heading">{title}</h1>
            </div>
            <div className="col-md-6 d-flex flex-row-reverse dataTables_search">
              <SearchTable
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          {isLoading ? (
            <h4>Loading...</h4>
          ) : commentsData == "" ? (
            <h4>विवरण उपलब्ध छैन</h4>
          ) : (
            <table className="table table-responsive local-table">
              <HeaderTable
                headers={headers}
                onSorting={(field, order) => setSorting({ field, order })}
              />
              <tbody>
                {commentsData.map((comment, i) => (
                  <tr>
                    <th scope="row" key={comment.id}>
                      {changeIndexToNepali(++i)}
                    </th>
                    <td style={{ minWidth: 150 }}>
                      <Link
                        onClick={() =>
                          handleministry_id(
                            comment.info.ministry_id,
                            comment.info.name.trim()
                          )
                        }
                        to={
                          `/details/${province_data[
                            sessionStorage.getItem("provinceId") - 1
                          ].trim()}?m_id=` + comment.info.name.trim()
                        }
                      >
                        {comment.info.name}
                      </Link>
                    </td>

                    {comment.stages.map((item, i) =>
                      i === 4 && comment.current_stage === 3 ? (
                        <td key={i++} style={{ minWidth: 150 }}>
                          <Link
                            onClick={() =>
                              handleministry_id(
                                comment.info.ministry_id,
                                comment.info.name.trim()
                              )
                            }
                            className="btn btn-primary"
                            to={
                              `/pfraform/${province_data[
                                sessionStorage.getItem("provinceId") - 1
                              ].trim()}?m_id=` + comment.info.name.trim()
                            }
                          >
                            पृष्ठपोषण गर्नुहोस्
                          </Link>
                        </td>
                      ) : i === 0 || i === 1 ? (
                        <td key={i++} style={{ minWidth: 150 }}>
                          {item.completion_date === "" ? (
                            "नभएको"
                          ) : (
                            <p>
                              {changeIndexToNepali(item.completion_date)} <br />{" "}
                              {item.score == "" ? (
                                "(-)"
                              ) : (
                                <Link
                                  onClick={() =>
                                    handleministry_id(
                                      comment.info.ministry_id,
                                      comment.info.name.trim()
                                    )
                                  }
                                  to={
                                    `/score/${province_data[
                                      sessionStorage.getItem("provinceId") - 1
                                    ].trim()}?m_id=` +
                                    comment.info.name.trim() +
                                    "&stage_id=" +
                                    item.stage_id
                                  }
                                >
                                  ({item.score})
                                </Link>
                              )}{" "}
                            </p>
                          )}{" "}
                        </td>
                      ) : i === 2 && localData === 6 ? (
                        // <td>
                        //   {item.completion_date === "" ? (
                        //     <ModalComp
                        //       fiscalYear={fiscalYear}
                        //       token={localData2}
                        //       gnid={comment.info.ministry_id}
                        //       disabled={comment.current_stage}
                        //       stage_id={3}
                        //       dateRequired={true}
                        //     />
                        //   ) : (
                        //     <p>
                        //       {changeIndexToNepali(item.completion_date)} <br />{" "}
                        //       {item.score == "" ? (
                        //         "(-)"
                        //       ) : (
                        //         <Link
                        //           onClick={() =>
                        //             handleministry_id(
                        //               comment.info.ministry_id,
                        //               comment.info.name.trim()
                        //             )
                        //           }
                        //           to={
                        //             `/score/${province_data[
                        //               sessionStorage.getItem("provinceId") - 1
                        //             ].trim()}?m_id=` +
                        //             comment.info.name.trim() +
                        //             "&stage_id=" +
                        //             item.stage_id
                        //           }
                        //         >
                        //           ({item.score})
                        //         </Link>
                        //       )}{" "}
                        //     </p>
                        //   )}
                        // </td>
                        <td>
                          {item.completion_date === "" ? (
                            comment.current_stage === 3 ? (
                              localData === 6 ? (
                                <div className="button-wraps">
                                  <Link
                                    onClick={() =>
                                      handleministry_id(
                                        comment.info.ministry_id,
                                        comment.info.name.trim()
                                      )
                                    }
                                    className="btn btn-primary"
                                    to={
                                      `/pfraform/${province_data[
                                        sessionStorage.getItem("provinceId") - 1
                                      ].trim()}?m_id=` +
                                      comment.info.name.trim()
                                    }
                                  >
                                    पृष्ठपोषण गर्नुहोस्
                                  </Link>
                                  <ModalComp
                                    fiscalYear={fiscalYear}
                                    token={localData2}
                                    gnid={comment.info.ministry_id}
                                    disabled={comment.current_stage}
                                    stage_id={3}
                                    localData={localData}
                                  />
                                </div>
                              ) : (
                                <Link
                                  onClick={() =>
                                    handleministry_id(
                                      comment.info.ministry_id,
                                      comment.info.name.trim()
                                    )
                                  }
                                  className="btn btn-primary"
                                  to={
                                    `/pfraform/${
                                      province_data[
                                        sessionStorage.getItem("provinceId") - 1
                                      ]
                                    }?m_id=` + comment.info.name
                                  }
                                >
                                  फारममा जानुहोस्
                                </Link>
                              )
                            ) : (
                              "नभएको"
                            )
                          ) : (
                            <p>
                              {changeIndexToNepali(item.completion_date)} <br />{" "}
                              {item.score == "" ? (
                                "(-)"
                              ) : (
                                <Link
                                  onClick={() =>
                                    handleministry_id(
                                      comment.info.ministry_id,
                                      comment.info.name.trim()
                                    )
                                  }
                                  to={
                                    `/score/${
                                      province_data[
                                        sessionStorage.getItem("provinceId") - 1
                                      ]
                                    }/?m_id=` +
                                    comment.info.name.trim() +
                                    "&stage_id=" +
                                    item.stage_id
                                  }
                                >
                                  ({item.score})
                                </Link>
                              )}{" "}
                            </p>
                          )}
                        </td>
                      ) : i === 3 ? (
                        <td>
                          {item.completion_date === "" ? (
                            comment.current_stage === 4 ? (
                              localData === 6 ? (
                                <div className="button-wraps">
                                  <Link
                                    onClick={() =>
                                      handleministry_id(
                                        comment.info.ministry_id,
                                        comment.info.name.trim()
                                      )
                                    }
                                    className="btn btn-primary"
                                    to={
                                      `/pfraform/${province_data[
                                        sessionStorage.getItem("provinceId") - 1
                                      ].trim()}?m_id=` +
                                      comment.info.name.trim()
                                    }
                                  >
                                    फारममा जानुहोस्
                                  </Link>
                                  <ModalComp
                                    fiscalYear={fiscalYear}
                                    token={localData2}
                                    gnid={comment.info.ministry_id}
                                    disabled={comment.current_stage}
                                    stage_id={4}
                                    localData={localData}
                                  />
                                </div>
                              ) : (
                                <Link
                                  onClick={() =>
                                    handleministry_id(
                                      comment.info.ministry_id,
                                      comment.info.name.trim()
                                    )
                                  }
                                  className="btn btn-primary"
                                  to={
                                    `/pfraform/${
                                      province_data[
                                        sessionStorage.getItem("provinceId") - 1
                                      ]
                                    }?m_id=` + comment.info.name
                                  }
                                >
                                  फारममा जानुहोस्
                                </Link>
                              )
                            ) : (
                              "नभएको"
                            )
                          ) : (
                            <p>
                              {changeIndexToNepali(item.completion_date)} <br />{" "}
                              {item.score == "" ? (
                                "(-)"
                              ) : (
                                <Link
                                  onClick={() =>
                                    handleministry_id(
                                      comment.info.ministry_id,
                                      comment.info.name.trim()
                                    )
                                  }
                                  to={
                                    `/score/${
                                      province_data[
                                        sessionStorage.getItem("provinceId") - 1
                                      ]
                                    }/?m_id=` +
                                    comment.info.name.trim() +
                                    "&stage_id=" +
                                    item.stage_id
                                  }
                                >
                                  ({item.score})
                                </Link>
                              )}{" "}
                            </p>
                          )}
                        </td>
                      ) : i === 5 ? (
                        <td>
                          {item.completion_date === "" &&
                          comment.current_stage === 4 ? (
                            localData === 3 ? (
                              <div className="button-wraps">
                                <Link
                                  onClick={() =>
                                    handleministry_id(
                                      comment.info.ministry_id,
                                      comment.info.name.trim()
                                    )
                                  }
                                  className="btn btn-primary"
                                  to={
                                    `/pfraform/${province_data[
                                      sessionStorage.getItem("provinceId") - 1
                                    ].trim()}?m_id=` + comment.info.name.trim()
                                  }
                                >
                                  फारममा जानुहोस्
                                </Link>
                                {/* <ModalComp
                                  fiscalYear={fiscalYear}
                                  token={localData2}
                                  gnid={comment.info.ministry_id}
                                  disabled={comment.current_stage}
                                  stage_id={6}
                                /> */}
                              </div>
                            ) : (
                              <Link
                                onClick={() =>
                                  handleministry_id(
                                    comment.info.ministry_id,
                                    comment.info.name.trim()
                                  )
                                }
                                className="btn btn-primary"
                                to={
                                  `/pfraform/${province_data[
                                    sessionStorage.getItem("provinceId") - 1
                                  ].trim()}?m_id=` + comment.info.name.trim()
                                }
                              >
                                फारममा जानुहोस्
                              </Link>
                            )
                          ) : item.completion_date === "" ? (
                            "नभएको"
                          ) : (
                            <p>
                              {changeIndexToNepali(item.completion_date)} <br />{" "}
                              {item.score == "" ? (
                                "(-)"
                              ) : (
                                <Link
                                  onClick={() =>
                                    handleministry_id(
                                      comment.info.ministry_id,
                                      comment.info.name.trim()
                                    )
                                  }
                                  to={
                                    `/score/${province_data[
                                      sessionStorage.getItem("provinceId") - 1
                                    ].trim()}?m_id=` +
                                    comment.info.name.trim() +
                                    "&stage_id=" +
                                    item.stage_id
                                  }
                                >
                                  ({item.score})
                                </Link>
                              )}{" "}
                            </p>
                          )}
                        </td>
                      ) : (
                        <td key={i++} style={{ minWidth: 150 }}>
                          {item.completion_date === "" ? (
                            "नभएको"
                          ) : (
                            <p>
                              {changeIndexToNepali(item.completion_date)} <br />{" "}
                              {item.score == "" ? (
                                "(-)"
                              ) : (
                                <Link
                                  onClick={() =>
                                    handleministry_id(
                                      comment.info.ministry_id,
                                      comment.info.name.trim()
                                    )
                                  }
                                  to={
                                    `/score/${province_data[
                                      sessionStorage.getItem("provinceId") - 1
                                    ].trim()}?m_id=` +
                                    comment.info.name.trim() +
                                    "&stage_id=" +
                                    item.stage_id
                                  }
                                >
                                  ({item.score})
                                </Link>
                              )}{" "}
                            </p>
                          )}
                        </td>
                      )
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
